import PropTypes from 'prop-types';
import MatchMedia from '../../../components/ui/MatchMedia/MatchMedia';
import { withApplicationContext } from '../../../utils/ApplicationContext';
import { noop } from '../../../utils/noop';
import { withProduct } from '../../../utils/ProductContext';
import ProductSpecificationsMobile from '../Softline/Mobile/ProductSpecificationMobile';
import ProductSpecificationsDesktop from './Desktop/ProductSpecifications';

const ModernProductSpecifications = ({
  isPumAvailable,
  pumQuantity,
  primeShipping,
  colorVariants,
  selectedColorSwatchIndex,
  colorSwatchHandler,
  sizes,
  selectedSize,
  sizeChangeHandler,
  handleAddToCart,
  operatorChangeHandler,
  operators,
  selectedOperatorId,
  isAddToCartInProgress,
  handleRemoveFromCart,
  isRemoveFromCartInProgress,
  addToCartButtonVisible,
  showCollectionButtonVisible,
  isVendorLogin,
  storeSkuData,
  currentTab,
  errorAddingToCart,
  requestProductFromStore,
  setShowLoginForm,
  showLoginForm,
  setErrorAddingToCart,
  sizeChartData,
  fomo,
  variantSwatchType,
  setWarrantyOption,
}) => {
  const specificationProps = {
    isPumAvailable,
    pumQuantity,
    primeShipping,
    colorVariants,
    selectedColorSwatchIndex,
    colorSwatchHandler,
    selectedSize,
    sizes,
    sizeChangeHandler,
    handleAddToCart,
    operatorChangeHandler,
    operators,
    selectedOperatorId,
    isAddToCartInProgress,
    handleRemoveFromCart,
    isRemoveFromCartInProgress,
    addToCartButtonVisible,
    showCollectionButtonVisible,
    isVendorLogin,
    storeSkuData,
    currentTab,
    errorAddingToCart,
    requestProductFromStore,
    setShowLoginForm,
    showLoginForm,
    setErrorAddingToCart,
    sizeChartData,
    fomo,
    variantSwatchType,
    setWarrantyOption,
  };

  return (
    <MatchMedia
      content={{
        desktop: () => <ProductSpecificationsDesktop {...specificationProps} />,
        mobile: () => <ProductSpecificationsMobile {...specificationProps} />,
        tablet: () => <ProductSpecificationsMobile {...specificationProps} />,
      }}
    />
  );
};

ModernProductSpecifications.defaultProps = {
  isPumAvailable: false,
  pumQuantity: 0,
  primeShipping: false,
  colorVariants: [],
  selectedColorSwatchIndex: 0,
  colorSwatchHandler: noop,
  sizes: [],
  selectedSize: undefined,
  sizeChangeHandler: noop,
  handleAddToCart: noop,
  operatorChangeHandler: noop,
  operators: [],
  selectedOperatorId: null,
  requestProductFromStore: noop,
  isAddToCartInProgress: false,
  handleRemoveFromCart: noop,
  isRemoveFromCartInProgress: false,
  addToCartButtonVisible: true,
  showCollectionButtonVisible: false,
  currentTab: '',
  errorAddingToCart: false,
  showLoginForm: false,
  sizeChartData: {},
  fomo: {},
  variantSwatchType: undefined,
  setWarrantyOption: noop,
};

ModernProductSpecifications.propTypes = {
  isPumAvailable: PropTypes.bool,
  pumQuantity: PropTypes.number,
  primeShipping: PropTypes.bool,
  colorVariants: PropTypes.array,
  selectedColorSwatchIndex: PropTypes.number,
  colorSwatchHandler: PropTypes.func,
  sizes: PropTypes.array,
  selectedSize: PropTypes.string,
  sizeChangeHandler: PropTypes.func,
  requestProductFromStore: PropTypes.func,
  handleAddToCart: PropTypes.func,
  operatorChangeHandler: PropTypes.func,
  operators: PropTypes.array,
  selectedOperatorId: PropTypes.string,
  isAddToCartInProgress: PropTypes.bool,
  handleRemoveFromCart: PropTypes.func,
  isRemoveFromCartInProgress: PropTypes.bool,
  addToCartButtonVisible: PropTypes.bool,
  showCollectionButtonVisible: PropTypes.bool,
  isVendorLogin: PropTypes.bool.isRequired,
  storeSkuData: PropTypes.object.isRequired,
  currentTab: PropTypes.string,
  errorAddingToCart: PropTypes.bool,
  setShowLoginForm: PropTypes.func.isRequired,
  setErrorAddingToCart: PropTypes.func.isRequired,
  showLoginForm: PropTypes.bool,
  sizeChartData: PropTypes.object,
  fomo: PropTypes.object,
  variantSwatchType: PropTypes.string,
  setWarrantyOption: PropTypes.func,
};

export default withProduct(withApplicationContext(ModernProductSpecifications));
